var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * NumberZeroFilled component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconNumberZeroFilled extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 23C14.9174 23 17.7153 21.8411 19.7782 19.7782C21.8411 17.7153 23 14.9174 23 12C23 9.08262 21.8411 6.28473 19.7782 4.22183C17.7153 2.15893 14.9174 1 12 1C9.08262 1 6.28473 2.15893 4.22183 4.22183C2.15893 6.28473 1 9.08262 1 12C1 14.9174 2.15893 17.7153 4.22183 19.7782C6.28473 21.8411 9.08262 23 12 23ZM9.83929 9.57686C9.83929 8.854 10.4254 8.26786 11.1483 8.26786H12.8517C13.441 8.26786 13.9407 8.65757 14.1041 9.195L9.83929 12.3929V9.57686ZM16.125 9.57686V14.4231C16.125 16.2303 14.6589 17.6964 12.8517 17.6964H11.1483C10.2802 17.6964 9.44758 17.3516 8.83372 16.7377C8.21986 16.1238 7.875 15.2913 7.875 14.4231V9.57686C7.875 7.76971 9.34114 6.30357 11.1483 6.30357H12.8517C14.6589 6.30357 16.125 7.76971 16.125 9.57686ZM9.89586 14.805L14.1607 11.6071V14.4231C14.1607 15.146 13.5746 15.7321 12.8517 15.7321H11.1483C10.8678 15.732 10.5948 15.6418 10.3693 15.4749C10.1439 15.308 9.97792 15.0732 9.89586 14.805Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconNumberZeroFilled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconNumberZeroFilled.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconNumberZeroFilled.prototype, "size", void 0);
if (customElements.get('cat-icon-number-zero-filled') === undefined) {
    customElements.define('cat-icon-number-zero-filled', BlocksIconNumberZeroFilled);
}
